import actions from '@/Core.Service.Domain/Users/Store/actions';
import getters from '@/Core.Service.Domain/Users/Store/getters';
import mutations from '@/Core.Service.Domain/Users/Store/mutations';

const state = {
  editUser: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
